var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { BLACK_800, BLACK_900, Card, TRANSPARENT, Typography, getTestId, useBreakpoint, checkIsPlatform } from '@airtel/air-design-system';
import { View } from 'react-native';
import { CarouselWidget } from '../carousel-widget';
import { getTestimonialWidgetStyles } from './TestimonialWidgetStyles';
export var TestimonialWidgetComponent = props => {
  var dataList = props.dataList,
    _props$backgroundColo = props.backgroundColor,
    backgroundColor = _props$backgroundColo === void 0 ? TRANSPARENT : _props$backgroundColo,
    breakPoints = props.breakPoints,
    style = props.style,
    _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'TestimonialWidget' : _props$testID,
    restProps = __rest(props, ["dataList", "backgroundColor", "breakPoints", "style", "testID"]);
  var _useBreakpoint = useBreakpoint({
      allowMdAsLargeScreen: true,
      returnAsObject: true
    }),
    isSmallScreen = _useBreakpoint.isSmallScreen;
  var testimonialWidgetStyles = getTestimonialWidgetStyles(isSmallScreen);
  var Testimonial = testimonialProps => {
    var description = testimonialProps.description,
      subtitle = testimonialProps.subtitle;
    var subtitleType = isSmallScreen ? 'body-single-line-sm-bold' : 'body-single-line-md-bold';
    var descriptionType = isSmallScreen ? 'body-para-sm' : 'body-para-md';
    return _jsxs(Card, Object.assign({
      style: testimonialWidgetStyles.cardContainer,
      backgroundColor: backgroundColor
    }, {
      children: [_jsx(Typography, Object.assign({
        text: "\u201C",
        type: "h1",
        style: testimonialWidgetStyles.quotes,
        color: BLACK_800
      }, checkIsPlatform('web') && {
        'aria-hidden': true
      })), _jsx(Typography, {
        text: description,
        type: descriptionType,
        color: BLACK_800
      }), _jsx(Typography, Object.assign({
        text: "\u201D",
        type: "h1",
        style: testimonialWidgetStyles.rightQuotes,
        color: BLACK_800
      }, checkIsPlatform('web') && {
        'aria-hidden': true
      })), _jsx(Typography, {
        text: subtitle,
        type: subtitleType,
        color: BLACK_900
      })]
    }));
  };
  var getTestimonialList = () => {
    var testimonialList = [];
    dataList.map((data, id) => {
      testimonialList.push(_jsx(Testimonial, Object.assign({}, data), 'testimonial_' + id));
    });
    return testimonialList;
  };
  return _jsx(_Fragment, {
    children: !!(dataList === null || dataList === void 0 ? void 0 : dataList.length) && _jsx(View, Object.assign({
      style: style
    }, getTestId(testID), {
      children: _jsx(CarouselWidget, Object.assign({
        data: getTestimonialList(),
        showNavigationCtas: true,
        breakPoints: breakPoints,
        carouselType: "COMPONENT",
        navigationCtaPosition: "relative",
        theme: "light",
        showNavigationCounter: false,
        alignment: "center"
      }, restProps))
    }))
  });
};
TestimonialWidgetComponent.genericRendererKey = 'AirTestimonialWidget';